import React from "react";
import WebBackBtn from "./webbackbtn";
import { Forgotpassword } from "../Account/MobileLoginTalwind";

export default function FPHeader({ BacktoSignin,Title,TitleDescription }) {
    return (
        <>
            <h2 className={Forgotpassword.Title} >{Title}</h2>
            <WebBackBtn clickfun={() => { BacktoSignin() }} />
            < p className={Forgotpassword.Titledesc} >
                {TitleDescription}
            </p>
        </>
    )
}